// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2481":"b22e55f1","2759":"b22e55f1","6352":"2d1d25ba","8062":"a32ad50e","8606":"472e7cf4"}[chunkId] + ".chunk.css";
};